import {
  FETCH_PLACES_DATA,
  FETCH_PLACES_SUCCESS,
  FETCH_PLACES_FAILURE,
  FETCH_PLACES_EDIT_DATA,
  FETCH_PLACES_EDIT_SUCCESS,
  FETCH_PLACES_EDIT_FAILURE,
} from "./actionTypes"

export const fetchPlacesData = () => ({
  type: FETCH_PLACES_DATA,
})

export const fetchPlacesSuccess = data => ({
  type: FETCH_PLACES_SUCCESS,
  payload: data,
})

export const fetchPlacesFailure = error => ({
  type: FETCH_PLACES_FAILURE,
  payload: error,
})

export const fetchPlacesEditData = id => ({
  type: FETCH_PLACES_EDIT_DATA,
  payload: id,
})

export const fetchPlacesEditSuccess = data => ({
  type: FETCH_PLACES_EDIT_SUCCESS,
  payload: data,
})

export const fetchPlacesEditFailure = error => ({
  type: FETCH_PLACES_EDIT_FAILURE,
  payload: error,
})
